import React from 'react';
import { Link } from "react-router-dom";
import DocsVideo from '../reusable_components/DocsVideo';

import teacher_view_navigate_video from '../videos/teacher_view_navigate_video.mov';
import teacher_view_search_video from '../videos/teacher_view_search_video.mov';
import teacher_view_filter_video from '../videos/teacher_view_filter_video.mov';
import teacher_view_place_video from '../videos/teacher_view_place_video.mov';
import teacher_view_create_section_video from '../videos/teacher_view_create_section_video.mov';
import teacher_view_quick_view_video from '../videos/teacher_view_quick_view_video.mov';

export default function TeacherViewDocs({ topic, setTopic, schoolType, embedded = false }) {
	const validTopics = ['teacher_view_basics'];
	const teacherViewTopic = embedded ? 'teacher_view_basics' : (validTopics.includes(topic) ? topic : 'default');

	const chooseTeacherViewTopic = (newTopic) => {
		if (teacherViewTopic === newTopic) {
			setTopic(null);
		} else {
			setTopic(newTopic);
		}

		scrollToInstructions('topOfThePage');
	};

	const scrollToInstructions = (sectionId) => {
		const section = document.getElementById(sectionId);
		if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
	};

	return (
		<div className='documentation-page'>
			{!embedded &&
				<>
					<p>Use Teacher View to review and adjust section placements by teacher across periods.</p>
					<p className='documentation-question-heading'>What would you like help with?</p>
					<div className='choose-topic' style={{ margin: '0px 0px 10px 0px' }}>
						<Link className={`choose-topic-btn ${teacherViewTopic === 'teacher_view_basics' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/magnetboard/teacher_view/${teacherViewTopic === 'teacher_view_basics' ? 'null' : 'teacher_view_basics'}`} onClick={() => chooseTeacherViewTopic('teacher_view_basics')}>Teacher view basics</Link>
					</div>
				</>
			}

			{teacherViewTopic === 'teacher_view_basics' &&
			<div id='topOfThePage' className='documentation-container'>
				<h2 className='documentation-page-heading'>Teacher View</h2>
				<div className='documentation-question-heading'>What would you like help with?</div>
				<div className='documentation-container-instruction-option-container'>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('teacher_view_navigate')}>Set up your view</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('teacher_view_find')}>Find data quickly</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('teacher_view_place')}>Place/unplace existing sections</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('teacher_view_create_section')}>Create a new section</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('teacher_view_quick_view')}>See section Quick View/Conflicts</div>
				</div>

				<div id='teacher_view_navigate' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Set up your view</div>
					<div className='documentation-step-text'>Start by choosing <span className='turquoise-text'>Teacher View</span>.</div>
					<div className='documentation-step-text'>If you have a schedule that has different rotations on different days of your cycle, then you will also have the option to choose <span className='turquoise-text'>Period View</span> or <span className='turquoise-text'>Day View</span>. Period View shows you you're rotation periods, and Day View shows you specific days in your rotation.</div>
					<DocsVideo src={teacher_view_navigate_video}></DocsVideo>
				</div>

				<div id='teacher_view_find' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Find data quickly</div>
					<div className='documentation-step-text'>Use the search bar to find teachers or courses. Search by teacher name, course name, or course code.</div> 
					<DocsVideo src={teacher_view_search_video}></DocsVideo>
					<div className='documentation-step-text'>You can also use the filter menu to filter the magnetboard by departments, teachers, classrooms, classroom status, singleton/doubleton, or labs.</div>
					<DocsVideo src={teacher_view_filter_video}></DocsVideo>
				</div>

				<div id='teacher_view_place' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Place/unplace existing sections</div>
					<div className='documentation-step-text'>To change a section's period, just drag it to the new period. This updates placement and recalculates conflicts/match percent.</div>
					<div className='documentation-step-text'>To place a section you already created, first click the underlined "unplaced sections" link under a teacher's name. This should open up the Unplace Sections dropzone, where you should see all sections assigned to this teacher. You can drag these unplaced sections on and off the board.</div>
					<DocsVideo src={teacher_view_place_video}></DocsVideo>
				</div>

				<div id='teacher_view_create_section' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Create a new section</div>
					<div className='documentation-step-text'>Use the plus icon in the bottom right of a period to add a new section.</div>
					<DocsVideo src={teacher_view_create_section_video}></DocsVideo>
				</div>

				<div id='teacher_view_quick_view' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>See section Quick View/Conflicts</div>
					<div className='documentation-step-text'>To see a quick overview of a section's details (including any conflicts), single click on a section. It should automatically open the section Quick View screen. This will also highlight the section and any connected/linked sections, so you can easily see what section you selected.</div>
					<div className='documentation-step-text'>To close the section Quick View, click on "Close" at the top right of the quick view.</div>
					<DocsVideo src={teacher_view_quick_view_video}></DocsVideo>
				</div>
			</div>
			}
		</div>
	);
}
